import React, { useRef, useState } from "react";
import weatherImg from "../assets/img/weatherImg2.png";
import homeIcon from "../assets/icons/thinkIcons/Home.png";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import rainyImg from "../assets/img/imageRainfall2.png";
import sunnyImg from "../assets/img/sunnyIMG.jpg";
import CloudyImg from "../assets/img/cloudyImg.jpg";
import SnowyIMG from "../assets/img/snowIMG.jpg";

const WeatherPrediction = () => {
  const [temperature, setTemperature] = useState();
  const [humidity, setHumidity] = useState();
  const [windSpeed, setWindSpeed] = useState();
  const [precipitation, setPrecipitation] = useState();
  const [pressure, setPressure] = useState();
  const [uvIndex, setUvIndex] = useState();
  const [visibility, setVisibility] = useState();
  const [cloudCover, setCloudCover] = useState("");
  const [season, setSeason] = useState("");
  const [location, setLocation] = useState("");
  const [loading, setLoading] = useState(false);
  const resultRef = useRef(null);

  const [predictionResult, setPredictionResult] = useState(null);
  const [inputData, setInputData] = useState({});
  const navigate = useNavigate();
  const predictionImages = {
    rainy: rainyImg,
    sunny: sunnyImg,
    cloudy: CloudyImg,
    snowy: SnowyIMG,
  };

  const handlePrediction = async () => {
    const payload = {
      Temperature: temperature,
      Humidity: humidity,
      Wind_Speed: windSpeed,
      Precipitation: precipitation,
      Atmospheric_Pressure: pressure,
      UV_Index: uvIndex,
      Visibility: visibility,
      Cloud_Cover: cloudCover,
      Season: season,
      Location: location,
    };

    // Validate all fields
    for (let [key, value] of Object.entries(payload)) {
      if (value === "" || value === null || value === undefined) {
        toast.error(`${key.replace(/_/g, " ")} is required`, {
          position: "top-right",
          autoClose: 3000,
        });
        return; // stop if any required field is missing
      }
    }
    setLoading(true);

    const endpoint = "/weather_prediction";

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}${endpoint}`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      setPredictionResult(res.data.prediction);
      setInputData(res.data.input);

      // 👇 scroll to result after prediction
      setTimeout(() => {
        resultRef.current?.scrollIntoView({ behavior: "smooth" });
      }, 300);
    } catch (error) {
      console.error("Weather Prediction API Error:", error);
      toast.error("Something went wrong while predicting weather", {
        position: "top-right",
        autoClose: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-2 md:p-8 lg:p-12">
      {/* Header Row */}
      <div className="flex justify-end">
        <button
          className="flex items-center gap-2 border  px-3 py-2 rounded-full cursor-pointer"
          onClick={() => navigate("/user/dashboard")}
        >
          <img src={homeIcon} className="w-[18px] h-[18px]" />
          <span className="text-xs">Home</span>
        </button>
      </div>

      {/* Top Card */}
      <div className="border-1 rounded-md mt-2 md:mt-4 flex p-2 md:p-3 gap-4  border-blue-custom">
        <img
          src={weatherImg}
          alt="House Image"
          className="w-full max-w-[200px] min-w-[160px] h-[120px] object-cover rounded-md"
        />
        <div className="">
          <h2 className="textcolor font-semibold text-xl">
            Weather Prediction
          </h2>
          <p className="textsec text-sm">
            Predict rainfall based on current weather conditions.
          </p>
        </div>
      </div>

      {/* Description */}
      <div className="desc-Text border-l-4 border-l-desc-Text pl-4 mt-4 text-lg font-semibold">
        <p className="font-medium m-0">Enter your weather parameters</p>
      </div>

      {/* Form Input */}
      <form className="my-2 sm:my-4 py-2 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        <Input
          label="Temperature (°C)"
          value={temperature}
          setValue={setTemperature}
          min={-50}
          max={60}
        />
        <Input
          label="Humidity (%)"
          value={humidity}
          setValue={setHumidity}
          min={0}
          max={100}
        />
        <Input
          label="Wind Speed (km/h)"
          value={windSpeed}
          setValue={setWindSpeed}
          min={0}
          max={200}
        />
        <Input
          label="Precipitation (%)"
          value={precipitation}
          setValue={setPrecipitation}
          min={0}
          max={100}
        />
        <Input
          label="Atmospheric Pressure (hPa)"
          value={pressure}
          setValue={setPressure}
          min={800}
          max={1100}
        />
        <Input
          label="UV Index"
          value={uvIndex}
          setValue={setUvIndex}
          min={0}
          max={15}
        />
        <Input
          label="Visibility (km)"
          value={visibility}
          setValue={setVisibility}
          min={0}
          max={50}
        />

        <Select
          label="Cloud Cover"
          value={cloudCover}
          setValue={setCloudCover}
          options={["Clear", "Partly Cloudy", "Overcast"]}
        />

        <Select
          label="Season"
          value={season}
          setValue={setSeason}
          options={["Spring", "Summer", "Autumn", "Winter"]}
        />

        <Select
          label="Location"
          value={location}
          setValue={setLocation}
          options={["Urban", "Rural", "Mountain", "Coastal"]}
        />
      </form>

      {/* Button */}
      <div className="mt-8 flex justify-center">
        <button
          onClick={handlePrediction}
          disabled={loading}
          className="bgbtn1 textwhite px-6 py-2 rounded shadow hover:bg-[#1376c2] transition"
        >
          {loading ? "Processing..." : "Predict Weather"}
        </button>
      </div>

      {/* Result */}
      {predictionResult && (
        <div className="border-1 border-blue-custom rounded-lg mt-4 p-3 md:p-8 lg:p-12">
          <div className="mb-2">
            <h2 className="text-xl font-semibold textprimary">
              Weather Condition of your Location
            </h2>
            <p className="textsec">
              Predict weather conditions with precision for every scenario.
            </p>
          </div>

          <div className="mb-6">
            <h3 className="text-lg font-semibold textcolor mb-2">
              Prediction Result
            </h3>

            <div className="relative">
              <img
                src={
                  predictionImages[predictionResult?.toLowerCase()] || sunnyImg
                }
                alt="Prediction"
                className="w-full h-40 object-cover object-center"
              />
              <div
                className="absolute top-2 left-2 textcolor font-medium px-4 py-1 rounded shadow"
                style={{
                  background: "linear-gradient(to right, #71B7EE 5%, white 5%)",
                }}
              >
                Predicted Weather: {predictionResult}
              </div>
            </div>
            <p className="text-xs textsec p-2">
              Note: The image displayed is a generic placeholder for the
              predicted weather type.
            </p>
          </div>

          <div>
            <h4 className="text-md font-semibold textprimary mb-3">
              Input Data Sent
            </h4>
            <div className="overflow-x-auto" ref={resultRef}>
              <table className="min-w-full text-center text-sm border-1 border-blue-custom rounded-xl">
                <thead className=" textcolor">
                  <tr>
                    {Object.keys(inputData || {}).map((key) => (
                      <th
                        key={key}
                        className="border-1 border-blue-custom px-4 py-2"
                      >
                        {key}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    {Object.values(inputData || {}).map((val, idx) => (
                      <td
                        key={idx}
                        className="border-1 border-blue-custom px-4 py-2"
                      >
                        {val ?? "--"}
                      </td>
                    ))}
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// Input Component
const Input = ({ label, value, setValue, min, max, step = "0.1" }) => (
  <div>
    <label className="block textblack text-sm font-semibold mb-1">
      {label}
    </label>
    <input
      type="number"
      value={value}
      min={min}
      max={max}
      placeholder={`Enter value between ${min} to ${max}`}
      step={step}
      onChange={(e) => {
        const val = e.target.value;
        const numVal = parseFloat(val);
        if (val === "" || (numVal >= min && numVal <= max)) {
          setValue(val === "" ? "" : numVal);
        }
      }}
      className="w-full rounded-xl p-3 border-1 border-blue-custom h-[56px] sm:h-[62px]"
    />
  </div>
);

// Select Component
const Select = ({ label, value, setValue, options }) => (
  <div>
    <label className="block text-gray-700 font-medium mb-1">{label}</label>
    <select
      value={value}
      onChange={(e) => setValue(e.target.value)}
      className="w-full rounded-xl p-3 border-1 border-blue-custom h-[56px] sm:h-[62px]"
    >
      <option value="">Select {label}</option>
      {options.map((opt) => (
        <option key={opt} value={opt}>
          {opt}
        </option>
      ))}
    </select>
  </div>
);

export default WeatherPrediction;
